import { render, staticRenderFns } from "./KnOrders.vue?vue&type=template&id=b51ebfc4"
import script from "./KnOrders.js?vue&type=script&lang=js&external"
export * from "./KnOrders.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports